import { Injectable, inject, DestroyRef } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Injectable({
  providedIn: 'root',
})
export class UrlTrackerService {
  private _destroyRef = inject(DestroyRef);
  private router = inject(Router);

  private prevUrl: string;

  get previousUrl(): string {
    return this.prevUrl;
  }

  constructor() {}

  trackPreviousUrl() {
    this.router.events
      .pipe(takeUntilDestroyed(this._destroyRef))
      .subscribe((e) => {
        if (e instanceof NavigationStart) {
          this.prevUrl = e.url;
        }
      });
  }
}
